export enum SynchronizationStateEnum {
    needsSaving = 0,
    synchronized = 1,
    needsDeleting = 2,
    synchronizationClash = 3,
    localOnly = 4,
}
